<template>
    <section id="dnarepair2" class="bg-primary">
        <div class="container py-5">
            <div class="col-12 my-5 w-title"><h3 class="text-title-content text-white wow slideInDown">{{SectionDnaRepair2.title}}<br>{{SectionDnaRepair2.title2}}</h3></div>
            <div class="row mb-5 d-flex flex-wrap">
                <div class="col-lg-3 col-6 wow slideInLeft">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/jantung.jpg" class="card-img-top rounded-circle border border-white border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2 text-white">{{SectionDnaRepair2.desc1}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 wow slideInUp">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/eczema.jpg" class="card-img-top rounded-circle border border-white border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2 text-white">{{SectionDnaRepair2.desc2}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 wow slideInUp">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/hair-problem.jpg" class="card-img-top rounded-circle border border-white border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2 text-white">{{SectionDnaRepair2.desc3}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 wow slideInRight">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/diet.jpg" class="card-img-top rounded-circle border border-white border-4" alt="...">
                        <div class="card-body px-0">
                            <p class="card-text fs-6 lh-2 text-white">{{SectionDnaRepair2.desc4}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SectionDnaRepair2',

  data(){
   return{
     lastScrollPosition: 0,
     SectionDnaRepair2:{
         title: null,
         title2:null,
         desc1: null,
         desc2: null,
         desc3: null,
         desc4: null
         }
   }
 },

  mounted(){
    axios.get(`../../lang.json`).then(response => {
            let dataSectionDnaRepair2
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionDnaRepair2 = response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionDnaRepair2= response.data.en[0];
            }
            this.SectionDnaRepair2.title = dataSectionDnaRepair2.SectionDnaRepair2.title
            this.SectionDnaRepair2.title2 = dataSectionDnaRepair2.SectionDnaRepair2.title2
            this.SectionDnaRepair2.desc1 = dataSectionDnaRepair2.SectionDnaRepair2.desc1
            this.SectionDnaRepair2.desc2 = dataSectionDnaRepair2.SectionDnaRepair2.desc2
            this.SectionDnaRepair2.desc3 = dataSectionDnaRepair2.SectionDnaRepair2.desc3
            this.SectionDnaRepair2.desc4 = dataSectionDnaRepair2.SectionDnaRepair2.desc4
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>
